import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
import useCWPContext from './context/useCWPContext';
import { DashboardProvider } from '../Dashboard/useDashboard';
import Filter from './components/Filter';
import Table from './components/Table';
import CwpDetailsModal from './components/CwpDetailsModal';
import {
  postCwpList,
  postCwpDetails,
  postChangeStatus,
  postRecoverStatus,
  postMultipleAppointmentRequest,
  postAppointtRequestUpdate,
} from '../../api/cwpMaintenance';
import CwpMultipleModal from './components/CwpMultipleModal';
import ApprovedAllModal from './components/ApprovedAllModal';
import RejectAllModal from './components/RejectAllModal';

export default function CWPMaintenance() {
  const auth = useStore((state) => state.auth);
  const date = new Date();
  const monthsOptions = [
    { label: 'ALL', value: null },
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ];
  const yearOptions = [];

  /* eslint-disable no-plusplus */
  for (let i = 2010; i <= date.getFullYear(); i++) {
    yearOptions.push({ label: i.toString(), value: i.toString() });
  }

  let departmenDefaulttFilter = null;
  if (auth.designation === 'admin') {
    departmenDefaulttFilter = { label: 'ALL', value: null };
  } else if (auth.designation === 'KASM' || auth.designation === 'KASS') {
    departmenDefaulttFilter = { label: 'KASD', value: 'KASD' };
  } else if (
    auth.designation === 'SAM' ||
    auth.designation === 'SAR' ||
    auth.designation === 'SAS'
  ) {
    departmenDefaulttFilter = { label: 'SALES', value: 'SAR' };
  }

  const defaultFilter = {
    department: departmenDefaulttFilter,
    manager: { label: 'ALL', value: null },
    kasssar: { label: 'ALL', value: null },
    month: [monthsOptions[0]],
    year: { label: date.getFullYear().toString(), value: date.getFullYear().toString() },
  };

  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [cwpData, setCwpData] = useState([]);
  const [cwpDetails, setCwpDetails] = useState({ toggle: false, data: [] });
  const [cwpDetailsMultiple, setCwpDetailsMultiple] = useState({
    toggle: false,
    loading: false,
    cwpDetMul: [],
    approval_status: '',
  });
  const [loading, setLoading] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [rowsSelected, setRowsSelected] = useState([]);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const searchCwp = async () => {
    try {
      setLoading(true);
      const statusType = {
        department: filterForm?.department?.label,
        manager_id: filterForm?.manager?.value,
        rep_id: filterForm?.kasssar?.value,
        month:
          filterForm?.month.filter((item) => item.value === null).length > 0
            ? null
            : filterForm?.month.map((row) => row.value).sort(),
        status: activeTab === 3 ? [3, 4] : [activeTab],
      };
      const response = await postCwpList(statusType);
      const { code, data } = response.data;

      if (code === '200') {
        setCwpData(data);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const clearCwp = () => {
    setFilterForm(defaultFilter);
    setClearFilter(true);
  };

  const handleViewAppointments = async (id) => {
    try {
      setCwpDetails({ toggle: false, data: [] });
      toast.loading('requesting data please wait');

      const response = await postCwpDetails({ ids: id });

      if (response.data.code === '200') {
        const details = response?.data?.data.map((row) => ({
          ...row,
          status_id: 0,
        }));

        setCwpDetails({ toggle: true, data: details });
      }

      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleUpdateAll = (row = null, status = null, isall = null) => {
    const statusText = status === 1 ? 'approved all appointments?' : 'reject all appointments?';
    Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to ${
        isall === true ? statusText : 'submit the approvals of the selected appointments?'
      } `,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<small style="color:#fff"> Confirm </small>',
      cancelButtonText: '<small style="color:#fff"> Cancel </small>',
    }).then((response) => {
      if (response.isConfirmed) {
        const cwpDetailsForm =
          isall === true
            ? {
                designation: auth.designation,
                data: row?.ids.split(',').map((id) => ({ id, status_id: status })),
              }
            : {
                designation: auth.designation,
                data: cwpDetails?.data
                  ?.filter((item) => item.status_id !== 0)
                  .map((item) => ({ id: item.id, status_id: item.status_id })),
              };
        try {
          postChangeStatus(cwpDetailsForm).then((res) => {
            const { code, message } = res.data;
            if (code === '200') {
              toast.success(message);
              searchCwp();
              setCwpDetails({ ...cwpDetails, toggle: false });
            }
          });
        } catch (error) {
          toast.error(error.message);
        }
      }
    });
  };

  const handleRecoverAll = (row = null, status = null, isall = null) => {
    const statusId = status === 4 ? 1 : 0;

    Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to recover all appointments?`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<small style="color:#fff"> Confirm </small>',
      cancelButtonText: '<small style="color:#fff"> Cancel </small>',
    }).then((response) => {
      if (response.isConfirmed) {
        const cwpDetailsForm =
          isall === true
            ? {
                designation: auth.designation,
                data: row?.ids.split(',').map((id) => ({ id, status_id: statusId })),
              }
            : {
                designation: auth.designation,
                data: cwpDetails?.data
                  ?.filter((item) => item.status_id !== 0)
                  .map((item) => ({ id: item.id, status_id: item.status_id })),
              };
        try {
          postRecoverStatus(cwpDetailsForm).then((res) => {
            const { code, message } = res.data;
            if (code === '200') {
              toast.success(message);
              searchCwp();
              setCwpDetails({ ...cwpDetails, toggle: false });
            }
          });
        } catch (error) {
          toast.error(error.message);
        }
      }
    });
  };

  const handleCwpDetailStatus = (e, status, row) => {
    if (e.target.checked) {
      if (status === 1) {
        document.getElementById(`${row.id}-status-reject`).checked = false;
      } else {
        document.getElementById(`${row.id}-status-approve`).checked = false;
      }
    }

    const details = {
      ...cwpDetails,
      data: cwpDetails?.data?.map((item) =>
        item.id === row.id ? { ...item, status_id: e.target.checked ? status : 0 } : item,
      ),
    };
    setCwpDetails(details);
  };

  const handleViewSelected = async (status) => {
    try {
      setCwpDetailsMultiple({ ...cwpDetailsMultiple, toggle: false, loading: true, cwpDetMul: [] });
      toast.loading('requesting data please wait');
      const request = rowsSelected.map((row) => ({
        ids: row.ids,
        status_id: row.status_id,
      }));
      const response = await postMultipleAppointmentRequest({ datas: request });
      const { code, data } = response.data;

      if (code === '200') {
        setCwpDetailsMultiple({
          ...cwpDetailsMultiple,
          toggle: true,
          loading: false,
          cwpDetMul: data,
          approval_status: status,
        });
        toast.dismiss();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleMultipleApproval = (status, isall = true) => {
    let statusCode;

    if (status === 1) {
      statusCode = 'approved';
    } else if (status === 3) {
      statusCode = 'reject';
    } else if (status === 0) {
      statusCode = 'recover';
    } else {
      statusCode = '';
    }

    const statusText = statusCode;

    Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to ${
        isall === true
          ? `${statusText} all appointments?`
          : 'submit the approvals of the selected appointments?'
      } `,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<small style="color:#fff"> Confirm </small>',
      cancelButtonText: '<small style="color:#fff"> Cancel </small>',
    }).then((response) => {
      if (response.isConfirmed) {
        const cwpDetailsForm = {
          designation: auth.designation,
          data: cwpDetailsMultiple?.cwpDetMul?.map((row) => ({ id: row.id, status_id: status })),
        };
        toast.loading('Please wait...');
        postAppointtRequestUpdate(cwpDetailsForm).then((res) => {
          const { code } = res.data;
          if (code === '200') {
            toast.dismiss();
            const message = `You have successfully ${statusText} ${cwpDetailsMultiple?.cwpDetMul?.length} number of request(s)`;
            toast.success(message);
            searchCwp();
            setCwpDetailsMultiple({
              ...cwpDetailsMultiple,
              toggle: false,
              loading: false,
              cwpDetMul: [],
              approval_status: '',
            });
          }
        });
      }
    });
  };

  useEffect(() => {
    searchCwp();
  }, [activeTab, clearFilter]);

  return (
    <DashboardProvider>
      <useCWPContext.Provider
        value={useMemo(
          () => ({
            auth,
            activeTab,
            cwpData,
            cwpDetails,
            setCwpDetails,
            setFilterForm,
            filterForm,
            monthsOptions,
            yearOptions,
            searchCwp,
            clearCwp,
            loading,
            handleUpdateAll,
            handleRecoverAll,
            handleViewAppointments,
            handleCwpDetailStatus,
            rowsSelected,
            setRowsSelected,
            handleViewSelected,
            cwpDetailsMultiple,
            setCwpDetailsMultiple,
            handleMultipleApproval,
          }),
          [
            filterForm,
            cwpData,
            loading,
            cwpDetails.toggle,
            cwpDetails,
            rowsSelected,
            setRowsSelected,
            cwpDetailsMultiple,
          ],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  {/* <Box sx={{ backgroundColor: '#fff' }}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                          value={activeTab}
                          onChange={handleChange}
                          aria-label='basic tabs example'
                        >
                          <Tab
                            label='Appointments'
                            id='cwp-appointments'
                            aria-controls='cwp-appointments'
                          />
                          <Tab
                            label='Deleted Appointments'
                            id='cwp-deleted-appointments'
                            aria-controls='cwp-deleted-appointments'
                          />
                        </Tabs>
                      </Box>
                      <TabPanel value={activeTab} index={0}>
                        <Table />
                      </TabPanel>
                      <TabPanel value={activeTab} index={1}>
                        <Table />
                      </TabPanel>
                    </Box> */}

                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab
                          label='For Manager Approval'
                          id='cwp-for-manager-approval'
                          aria-controls='cwp-for-manager-approval'
                        />

                        <Tab
                          label='For Admin Approval'
                          id='cwp-for-admin-approval'
                          aria-controls='cwp-for-admin-approval'
                        />

                        <Tab label='Approved' id='cwp-approved' aria-controls='cwp-approved' />
                        <Tab label='Rejected' id='cwp-rejected' aria-controls='cwp-rejected' />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      <Table />
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <CwpMultipleModal />
        <ApprovedAllModal />
        <RejectAllModal />
        <CwpDetailsModal />
      </useCWPContext.Provider>
    </DashboardProvider>
  );
}
